

































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { SigningHelper } from '../../../helpers/signing.helper';
import type { BankId } from '../../../types/bankid';
import { BankIdStep, HintCodePending } from '../../../types/enums/bankid-se';

@Component
export default class BankIdSsn extends Vue {
  @Prop() bankId: BankId;
  ssn = '';

  get startValidate(): boolean {
    return this.ssn.length >= 10;
  }

  get validSsn(): boolean {
    return SigningHelper.validateSsn(this.ssn);
  }

  get showInvalidSsnText(): boolean {
    return !this.validSsn && this.startValidate;
  }

  get isLoading(): boolean {
    return this.bankId.step === BankIdStep.Polling;
  }

  get descriptionText(): string {
    return this.bankId.hintCode === HintCodePending.userSign
      ? `${this.$t('waiting-for-signature')}. `
      : this.$t('start-your-bankid-app-or').toString();
  }

  handleCancel() {
    this.$emit('cancel', this.ssn);
  }

  handleStartSSN() {
    this.$emit('startSSN', this.ssn);
  }

  @Watch('bankId.ssn')
  setSsn() {
    if (this.bankId.ssn) {
      this.ssn = this.bankId.ssn;
    }
  }

  mounted() {
    this.setSsn();
  }
}
